const doc = [({"zh_cn":({"buttonCheckIn":({"addGuest":"添加客人", "addRoom":"添加房间", "deleteGuest":"移除客人", "deleteRoom":"删除客房", "register":"办理入住手续"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;